import Swiper from '@src/components/swiper';
import { screenResizerChecker } from '@src/utils/screen-resizer-checker';
import { ScreensInt } from '@tailwindConfig/screens.config';

document.addEventListener('DOMContentLoaded', function(_event) {
  let mySwiperIntegrationList;

  const generateSwiperIntegrationList = () => {
    if (!mySwiperIntegrationList) {
      mySwiperIntegrationList = new Swiper('.swiper-integration-list', {
        grabCursor: true,
        slidesPerView: 'auto',
        spaceBetween: 48,
        pagination: {
          el: '.swiper-pagination-integration-list',
          clickable: true,
        },
      })
    };
  };

  const removeSwiperIntegrationList = () => {
    if (mySwiperIntegrationList) {
      $('.swiper-integration-list').each(function(){
        this.swiper.destroy();
      });
      mySwiperIntegrationList = null;
    }
  };

  screenResizerChecker(
    () => generateSwiperIntegrationList(),
    () => removeSwiperIntegrationList(),
    ScreensInt.md
  );
});
